
//Libraries
import { defineComponent } from "vue";

export default defineComponent({
  name: "Questions",
  setup() {
    //Lifecycle Hooks
  },
});
